import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/pos-api";
import { cachedImage, imageScope, loadProductImage } from '@/lib/product-image-cache';

export default function ApiImage({ src, alt = "", thumbnail = false, ...props }) {
  const internal = typeof src === "string" && src.startsWith("/api/");
  const product = internal && /^\/api\/(?:v1\/)?files\/poskasirsm\/products\//.test(src);
  const source = product && thumbnail ? `${src}${src.includes('?') ? '&' : '?'}thumb=card-v1` : src;
  const scope = internal ? imageScope() : '';
  const key = JSON.stringify([source, scope]);
  const element = useRef(null);
  const [visible, setVisible] = useState(null);
  const [blob, setBlob] = useState(null);
  useEffect(() => {
    if (!product || !globalThis.IntersectionObserver) { setVisible(key); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { setVisible(key); observer.disconnect(); }
    }, { rootMargin: '160px' });
    if (element.current) observer.observe(element.current);
    return () => observer.disconnect();
  }, [key, product]);
  useEffect(() => {
    if (!internal || (product && visible !== key && !cachedImage(source, scope))) return;
    const controller = new AbortController();
    let objectUrl;
    setBlob(null);
    // Fetch through the authenticated API client so master images use the selected tenant.
    const request = product ? loadProductImage(source, scope)
      : api.get(source, { baseURL: window.location.origin, responseType: "blob", signal: controller.signal }).then(r => r.data);
    request.then(data => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(data);
        setBlob({ key, url: objectUrl });
      }).catch(() => {});
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [source, internal, product, scope, key, visible]);
  return <img {...props} ref={element} decoding="async" alt={alt} src={internal ? (blob?.key === key ? blob.url : undefined) : src} />;
}
